function chatLoadScript() {
    /* eslint-disable */
    !function(e,n,t,r){
        function o(){try{var e;if((e="string"==typeof this.response?JSON.parse(this.response):this.response).url){var t=n.getElementsByTagName("script")[0],r=n.createElement("script");r.async=!0,r.src=e.url,t.parentNode.insertBefore(r,t)}}catch(e){}}var s,p,a,i=[],c=[];e[t]={init:function(){s=arguments;var e={then:function(n){return c.push({type:"t",next:n}),e},catch:function(n){return c.push({type:"c",next:n}),e}};return e},on:function(){i.push(arguments)},render:function(){p=arguments},destroy:function(){a=arguments}},e.__onWebMessengerHostReady__=function(n){if(delete e.__onWebMessengerHostReady__,e[t]=n,s)for(var r=n.init.apply(n,s),o=0;o<c.length;o++){var u=c[o];r="t"===u.type?r.then(u.next):r.catch(u.next)}p&&n.render.apply(n,p),a&&n.destroy.apply(n,a);for(o=0;o<i.length;o++)n.on.apply(n,i[o])};var u=new XMLHttpRequest;u.addEventListener("load",o),u.open("GET","https://"+r+".webloader.smooch.io/",!0),u.responseType="json",u.send()
    }(window,document,"Smooch",Odigeo.SessionScope.chatAppId);
    /* eslint-enable */
}

module.exports = {
    initChat: Odigeo._.once(function() {
        chatLoadScript();
    }),
    openChat: function(dataPayload, customText, embeddedMode = true) {
        return new Promise((resolve, reject) => {
            console.log('SMOOCH INIT');
            console.log('Odigeo.SessionScope: ', Odigeo.SessionScope);

            const locale = Odigeo.SessionScope.locale.split('_')[0];
            const device = Odigeo.SessionScope.flow;
            const brand = Odigeo.SessionScope.brand;
            const website = Odigeo.SessionScope.website.toLowerCase();
            const brandWebsiteLabel = (brand === 'ED' ? brand.toLowerCase() : '') + website;

            // eslint-disable-next-line
            Smooch.init({
                appId: Odigeo.SessionScope.chatAppId,
                embedded: embeddedMode,
                delegate: {
                    beforeSend(message) {
                        const metadata = message.metadata ? message.metadata : {};
                        metadata.initLocale = locale;
                        metadata.widgetRef = `widget-smchat-${brandWebsiteLabel}`;
                        metadata.device = device;
                        message.metadata = metadata;
                        return message;
                    },
                    beforePostbackSend(postback) {
                        const metadata = postback.metadata ? postback.metadata : {};
                        metadata.initLocale = locale;
                        metadata.widgetRef = `widget-smchat-${brandWebsiteLabel}`;
                        metadata.device = device;
                        postback.metadata = metadata;
                        return postback;
                    },
                },
                locale: locale,
                customText: {
                    ...customText,
                },
                menuItems: {
                    imageUpload: false,
                    fileUpload: false,
                    shareLocation: false,
                },
            }).then(
                function() {
                    const {text} = customText;
                    const intent = 'pause_deeplink';
                    const payload = {
                        locale: locale,
                        market: website,
                        brand: brand,
                        ...dataPayload,
                    };
                    const deeplink = {
                        intent,
                        payload: JSON.stringify(payload),
                    };
                    const message = {
                        type: 'text',
                        text,
                        metadata: {
                            deeplink: JSON.stringify(deeplink),
                        },
                    };

                    const messageToSend = dataPayload ? message : customText.text;
                    // eslint-disable-next-line
                    Smooch.sendMessage(messageToSend).then(() => {
                        // eslint-disable-next-line
                        Smooch.open();
                        resolve('Smooch send message success');
                    }).catch((err) => {
                        reject('Smooch send message error: ' + JSON.stringify(err));
                    });
                },
            ).catch((err) => {
                reject('Smooch Init error: ' + JSON.stringify(err));
            });

            if (embeddedMode) {
                // eslint-disable-next-line
                Smooch.render(document.getElementById('direct-chat-container'));
            }
        });
    },
    closeChat: function() {
        // eslint-disable-next-line
        Smooch.destroy();
    },
    sendResume: function() {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line
            Smooch.sendMessage('/resume/').then(() => {
                resolve('Resume sent ok');
            }).catch((err) => {
                reject('Resume error: ' + JSON.stringify(err));
            });
        });
    },
};
